import { referencesApi, ReferencesApiTypes } from 'api'
import { useApiRequest } from 'hooks/useApiRequest'
import { useCompanyId } from 'hooks/useCompanyId'
import { useEffect, useState } from 'react'

export type EquipmentDetailsData = {
  locations: ReferencesApiTypes.LocationsResponse['items']
  extras: ReferencesApiTypes.AllExtraTypesResponse['items']
}

export const useGetEquipmentDetails = () => {
  const [equipmentDetailsData, setEquipmentDetailsData] =
    useState<EquipmentDetailsData>({
      locations: [],
      extras: [],
    })

  const companyId = useCompanyId()

  const getAllCompanyHirePointsRequest = useApiRequest(() =>
    referencesApi.getAllCompanyHirePoints(String(companyId))
  )
  const getAllExtraTypesRequest = useApiRequest((companyId) =>
    referencesApi.getAllExtraTypes(companyId)
  )

  useEffect(() => {
    if (companyId) {
      const fetchLocations = async () => {
        const [locations, extras] = await Promise.all([
          getAllCompanyHirePointsRequest.apiRequest(),
          getAllExtraTypesRequest.apiRequest(companyId),
        ])
        if (locations && extras) {
          setEquipmentDetailsData((prevState) => ({
            ...prevState,
            locations: locations.data.items,
            extras: extras.data.items,
          }))
        }
      }
      fetchLocations()
    }
  }, [companyId])

  return {
    equipmentDetailsData,
    isLoaded:
      getAllCompanyHirePointsRequest.isLoaded &&
      getAllExtraTypesRequest.isLoaded,
  }
}
